// components/misc/DataTranslationNode.js
import React from "react";

const DataTranslationButtonNode = ({ data, style }) => {
  const handleClick = () => {
    if (data.onClick) {
      data.onClick();
    }
  };
  return (
    <div
      className="p-2 text-white bg-blue-500 border border-blue-400 rounded-md cursor-pointer hover:bg-blue-600"
      style={{ ...style }}
      onClick={handleClick}
    >
      <div>
        <p className="font-bold text-center">{data.label}</p>
      </div>
    </div>
  );
};
export default DataTranslationButtonNode;
